const brandingName = 'branding';
const accountIdName = 'accountId';
export const getCustomBrandingFromStorage = () => {
    const customBrandingString = localStorage.getItem(brandingName) || '{}';
    const customBranding = JSON.parse(customBrandingString);
    return customBranding;
};
export const saveCustomBrandingToStorage = (customBranding, accountId) => {
    localStorage.setItem(brandingName, JSON.stringify(customBranding));
    localStorage.setItem(accountIdName, accountId);
};
export const getAccountIdFromStorage = () => {
    return localStorage.getItem(accountIdName) || '';
};
export const saveAccountIdToStorage = (accountId) => {
    localStorage.setItem(accountIdName, accountId);
};
export const clearCustomBranding = () => {
    localStorage.removeItem(brandingName);
};
